import BootstrapTable, { BootstrapTableProps } from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { setCurrentPage, setTablePageSize } from '../../../redux/actions';
import { ReactNode } from 'react';
import { HistoryAudioType } from '../../../types/AppTypes';
import { HistoryDocumentType } from '../../../types/AppTypes';
import { formatOptions } from '../../../utils/utils';

type Props = {
  dataAudio: HistoryAudioType[] | undefined;
  dataDocument: HistoryDocumentType[] | undefined;
};

const HistoryTable = ( props : Props): JSX.Element => {

  const columnsAudio = [
    {
      dataField: 'version',
      text: 'Revision',
      headerAlign: 'center',
      align: 'center',
      sort: true,
    },
    {
      dataField: 'username',
      text: 'User',
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: 'created',
      text: 'Date',
      formatter: (cell: string): string => {
        const utcDate = new Date(cell);

        const date = utcDate.toLocaleTimeString('en-US', formatOptions);

        return date;
      },
      headerAlign: 'center',
      align: 'center',
      sort: true,
    },
    {
      dataField: 'autoDeployed',
      text: 'Autodeployed',
      headerAlign: 'center',
      align: 'center',
    }
  ];

  const columnsDocument = [
    {
      dataField: 'revision',
      text: 'Revision',
      headerAlign: 'center',
      align: 'center',
      sort: true,
    },
    {
      dataField: 'username',
      text: 'User',
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: 'date',
      text: 'Date',
      formatter: (cell: string): string => {
        const utcDate = new Date(cell);

        const date = utcDate.toLocaleTimeString('en-US', formatOptions);

        return date;
      },
      headerAlign: 'center',
      align: 'center',
      sort: true,
    }
  ];

  const dispatch = useAppDispatch();
  const tablePageSizeA = useAppSelector((state) => state.historyAudio.tablePageSize);
  const currentPageA = useAppSelector((state) => state.historyAudio.currentPage);

  const tablePageSizeD = useAppSelector((state) => state.historyDocument.tablePageSize);
  const currentPageD = useAppSelector((state) => state.historyDocument.currentPage);

  const paginationA = paginationFactory({
    sizePerPage: parseInt(localStorage.getItem('historyAudio-table-size') || '', 10) || tablePageSizeA,
    page: currentPageA,
    onPageChange: (page) => {
      dispatch(setCurrentPage(page));
    },
    onSizePerPageChange: (sizePage) => {
      sizePerPageGroupsChangeA(sizePage);
      dispatch(setTablePageSize(sizePage));
    },
  });

  const paginationD = paginationFactory({
    sizePerPage: parseInt(localStorage.getItem('historyDocument-table-size') || '', 10) || tablePageSizeD,
    page: currentPageD,
    onPageChange: (page) => {
      dispatch(setCurrentPage(page));
    },
    onSizePerPageChange: (sizePage) => {
      sizePerPageGroupsChangeD(sizePage);
      dispatch(setTablePageSize(sizePage));
    },
  });

  const sizePerPageGroupsChangeA = (sizePerPage: number) => {
    localStorage.setItem('historyAudio-table-size', sizePerPage.toString());
  };

  const sizePerPageGroupsChangeD = (sizePerPage: number) => {
    localStorage.setItem('historyDocument-table-size', sizePerPage.toString());
  };

  return (
    <>
      <div style={{ marginBottom: '20px' }}>
        <div style={{ marginBottom: '15px',fontSize:'15px', fontWeight:500 }}>Audio Revisions</div>
        <ToolkitProvider
          keyField="id"
          data={props.dataAudio}
          columns={columnsAudio}
          striped
          hover
          condensed
        >
          {(props: {
            baseProps: JSX.IntrinsicAttributes &
            JSX.IntrinsicClassAttributes<BootstrapTable<any, number>> &
            Readonly<BootstrapTableProps<any, number>> &
            Readonly<{ children?: ReactNode; }>;
          }) => (
            <div>
              <BootstrapTable {...props.baseProps} pagination={paginationA} rowStyle={{ wordBreak: 'break-word' }} />
            </div>
          )}
        </ToolkitProvider>
      </div>
      <div style={{ marginBottom: '15px' }}>
        <div style={{ marginBottom: '15px',fontSize:'15px', fontWeight:500 }}>Document Revisions</div>
        <ToolkitProvider
          keyField="id"
          data={props.dataDocument}
          columns={columnsDocument}
          striped
          hover
          condensed
        >
          {(props: {
            baseProps: JSX.IntrinsicAttributes &
            JSX.IntrinsicClassAttributes<BootstrapTable<any, number>> &
            Readonly<BootstrapTableProps<any, number>> &
            Readonly<{ children?: ReactNode; }>;
          }) => (
            <div>
              <BootstrapTable {...props.baseProps} pagination={paginationD} rowStyle={{ wordBreak: 'break-word' }} />
            </div>
          )}
        </ToolkitProvider>
      </div>
    </>
  );
};

export default HistoryTable;
